import { createContext } from 'react'
import { TRetailerContext } from '../types'

export const defaultRetailerContext: TRetailerContext = <TRetailerContext>{}

export const RetailerContext = createContext<TRetailerContext>(
  defaultRetailerContext
)
